export default "__VITE_ASSET__B9Yh1jLz__"